import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import ContentBlockWrapper from './../../../components/ContentBlockWrapper'
import EmptyContent from '../../../components/EmptyContent'
import { SignatureBox } from './TabContentStyled'
import { Card, Col, message, Popconfirm, Row, Tooltip } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { apiUrl } from '../../../config'
import { ACL_ACTION_TYPE, SIGNATURE_TYPE } from '../../../constants'
import AccessControlAction from '../../../components/AccessControlAction'

const { Meta } = Card

const MySign = props => {
  const {
    signedDocumentStore,
    loadingAnimationStore,
    authenticationStore,
  } = props

  const { signatureList } = signedDocumentStore
  const { currentUser } = authenticationStore

  const handleDeleteSignature = async (signId, name_signature) => {
    loadingAnimationStore.showSpinner(true)
    try {
      await signedDocumentStore.deleteSignature(signId)
      message.success(
        <span>
          Bạn đã xóa chữ ký <b>{name_signature}</b> thành công!
        </span>
      )
      load().then()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    load().then()
    return () => signedDocumentStore.clearSignatureStore()
  }, [currentUser])

  const load = async () => {
    if (currentUser) {
      loadingAnimationStore.showSpinner(true)
      try {
        await signedDocumentStore.getSignatureList({
          user_name: currentUser.username,
        })
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
  }

  const renderStatusSignature = type => {
    if (type === SIGNATURE_TYPE.PENDING) {
      return (
        <span style={{ color: '#1890ff', fontSize: 12, fontWeight: 500 }}>
          Chờ duyệt
        </span>
      )
    }
    if (type === SIGNATURE_TYPE.APPROVAL) {
      return (
        <span style={{ color: '#52c41a', fontSize: 12, fontWeight: 500 }}>
          Đã duyệt
        </span>
      )
    }
    if (type === SIGNATURE_TYPE.REJECT) {
      return (
        <span style={{ color: '#f5222d', fontSize: 12, fontWeight: 500 }}>
          Từ chối
        </span>
      )
    }
    return (
      <span style={{ color: '#722ed1', fontSize: 12, fontWeight: 500 }}>
        Không rõ
      </span>
    )
  }

  return (
    <ContentBlockWrapper>
      {signatureList ? (
        <Row gutter={[30, 30]}>
          {signatureList.map(signature => (
            <Col md={24} lg={12} xl={8} key={signature.id}>
              <SignatureBox>
                <Card
                  hoverable
                  className={'card'}
                  cover={
                    <div className={'img-box'}>
                      <img
                        alt="signature"
                        src={`${apiUrl}/api/v1/images/${signature.signId}`}
                      />
                    </div>
                  }>
                  <Meta
                    title={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          fontSize: 14,
                        }}>
                        <div style={{ fontWeight: 400, color: '#333' }}>{signature.signName}</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          {renderStatusSignature(signature.status)}
                          <AccessControlAction
                            aclActionType={ACL_ACTION_TYPE.delete__CHU_KY_CUA_TOI}>
                            <Popconfirm
                              placement="top"
                              title={'Bạn có chắc chắn muốn xóa chữ ký này?'}
                              onConfirm={() =>
                                handleDeleteSignature(
                                  signature.signId,
                                  signature.signName
                                )
                              }
                              okText="Đồng ý"
                              cancelText="Hủy bỏ">
                              <Tooltip placement="top" title="Xóa chữ ký">
                                <DeleteOutlined
                                  style={{ fontSize: 16, color: '#1890ff', cursor: 'pointer' }}
                                />
                              </Tooltip>
                            </Popconfirm>
                          </AccessControlAction>
                        </div>
                      </div>
                    }
                  />
                </Card>
              </SignatureBox>
            </Col>
          ))}
        </Row>
      ) : (
        <EmptyContent description={'Bạn chưa có chữ ký nào, hãy tạo chữ ký!'} />
      )}
    </ContentBlockWrapper>
  )
}

MySign.propTypes = {}

export default inject(
  'signedDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
)(observer(MySign))
